import Button from '../Button/Button';

const SubjectCard = ({
  subjectHeader,
  subject,
  description,
  selectSubject,
  selectedSubjects,
  id,
  type,
}) => {
  return (
    <div className='school-card' style={{ cursor: 'pointer' }}>
      <img src={subjectHeader} alt='' className='school-card__school-img' />
      {type !== 'dashboard' && (
        <div className='school-card__check'>
          {selectedSubjects?.includes(id) ? (
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM17.99 9L16.58 7.58L9.99 14.17L7.41 11.6L5.99 13.01L9.99 17L17.99 9Z'
                fill='#FEA82F'
              />
            </svg>
          ) : (
            <svg
              width='18'
              height='18'
              viewBox='0 0 18 18'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M16 2V16H2V2H16ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0Z'
                fill='#FEA82F'
              />
            </svg>
          )}
        </div>
      )}
      <div className='school-card__body'>
        <div className='school-card__body__title'>
          <h3>{subject}</h3>
          {description ? (
            <p>
              {description.length > 120
                ? `${description.substring(0, 110)}...`
                : description}
            </p>
          ) : (
            <p>No description available for this lesson</p>
          )}
        </div>
        {type === 'dashboard' ? (
          <div style={{ marginTop: '32px' }}>
            <Button
              text='Start Learning'
              className='orange-border'
              width='100%'
              onClick={selectSubject}
            />
          </div>
        ) : (
          <div style={{ marginTop: '32px' }}>
            {selectedSubjects?.includes(id) ? (
              <Button
                text='Selected'
                className='primary-btn'
                width='100%'
                onClick={selectSubject}
              />
            ) : (
              <Button
                text='Select Subject'
                className='orange-border'
                width='100%'
                onClick={selectSubject}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SubjectCard;
